import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function OfferSection() {
  return <section id="oferta" className="py-10 px-4 md:px-8 relative overflow-hidden" data-id="element-115">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-radial-cyan opacity-30 pointer-events-none" data-id="element-116" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true
      }} className="bg-[#0f1628]/40 backdrop-blur-md border border-cyan-500/30 rounded-3xl p-8 md:p-16 shadow-2xl shadow-slate-900/30 text-center" data-id="element-118">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-119">
            <div className="order-2 md:order-1" data-id="element-120">
              <img src="https://cdn.magicpatterns.com/uploads/3q5xfZZMKHm7tyiT75L2ZH/grok-image-4b2b4708-b74a-4eb6-b258-7a30fd801c8c.png" alt="El Código del Sueño Profundo" className="w-full max-w-sm mx-auto drop-shadow-2xl rounded-xl" data-id="element-121" />
            </div>

            <div className="order-1 md:order-2 text-center md:text-left" data-id="element-122">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-123">
                Recupera tu derecho a descansar.
              </h2>
              <p className="text-lg text-[#b8c4d6] mb-8" data-id="element-124">
                Por menos de lo que cuesta una cena o un frasco de suplementos
                que no funcionan, puedes tener el plano completo para dominar tu
                descanso de por vida.
              </p>

              <div className="mb-8" data-id="element-125">
                <span className="inline-block px-3 py-1 rounded-full mb-4 uppercase tracking-wider text-[14px] text-[#f5f5f5] bg-[#00bfff] font-[700]" data-id="element-126">
                  Precio Especial de Lanzamiento
                </span>
                <div className="flex items-center justify-center md:justify-start gap-4 mb-2" data-id="element-127">
                  <span className="text-5xl md:text-6xl font-bold text-white" data-id="element-128">
                    $6.39
                  </span>
                  <span className="inline-block px-3 py-1 bg-cyan-500/20 text-cyan-400 text-sm font-bold rounded-lg" data-id="element-129">
                    -76% OFF
                  </span>
                </div>
                <p className="text-gray-500 text-lg line-through" data-id="element-130">$27.00</p>
              </div>

              <CTAButton text="DESCUBRE AHORA" data-id="element-131" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}